<script>
import formatDate from '@utils/format-date'
import { orderPaymentMethodMap, paymentStatusMapFilter, bookingStatusFilter } from '@utils/filter-value-to-text'
import cloneDeep from 'lodash/cloneDeep'
import { calcTotal } from '@utils/order-form'
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
const initData = () => {
  return {
    params: [],
  }
}

const totalEditTypes = () => ['+', '-', '%', 'express']

export default {
  filters: {
    formatDate,
    paymentStatusMapFilter,
    bookingStatusFilter,
  },
  components: {},
  mixins: [memberLevelDiscountMixin],
  props: {
    orderType: {
      type: String,
      validator: (val) => {
        return ['reservation', 'prepaid', 'deposit', 'goods'].includes(val)
      },
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    defaultCoupon: {
      type: Object,
      default: () => ({}),
    },
    enabledEdit: {
      type: Boolean,
      default: false,
    },
    enabledAddition: {
      type: Boolean,
      default: false,
    },
    buyingPrepaidInfo: {
      type: Object,
      default: () => ({}),
    },
    isOrderCreated: {
      type: Boolean,
      default: false,
    },
    memberInfo: {
      type: Object,
      required: true,
    },
    isChildrenOrderCreating: {
      type: Boolean,
      default: false,
    },
    // 判斷是否只是美容師
    isEmployee: {
      type: Boolean,
      default: false,
    },
    containerEdit: {
      type: Boolean,
      default: false,
    },
    orderSecondType: {
      type: String,
      default: 'deposit',
    },
    addressEditCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      orderPaymentMethodMap,
      submitData: {},
      MaxQty: 1,
      mainTableItemShow: true,

      reservationTypes: ['cosmetic-add', ...totalEditTypes()],
      prepaidTypes: [...totalEditTypes()],
      depositTypes: [...totalEditTypes()],
      goodsTypes: [...totalEditTypes()],

      basicParams: [],
      totalEditParams: [],

      deleteIds: [],
    }
  },
  computed: {
    /**
     * @description 療程/包月 有會員等級後的價錢
     */
    prepaidInfoLevelDiscountPrice() {
      try {
        let price = undefined
        if (this.buyingPrepaidInfoDiscountIndex > -1) {
          const { discountType, discount } = this.memberInfo.level.prepaids[this.buyingPrepaidInfoDiscountIndex]
          const cur = this.buyingPrepaidInfo
          price = discountType === '%' ? cur.price - cur.price * (discount / 100) : cur.price - discount
          price = price < 0 ? 0 : price
        }
        return price
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 購買包月的折扣index
     */
    buyingPrepaidInfoDiscountIndex() {
      if (this.memberInfo?.level && Object.keys(this.buyingPrepaidInfo).length > 0) {
        const { prepaids } = this.memberInfo?.level
        const index = prepaids.findIndex((prepaidItem) => prepaidItem.id === this.buyingPrepaidInfo.prepaidId)
        return index
      } else {
        return -1
      }
    },
    /**
     * @description 一般服務
     */
    serviceItem() {
      const multiple = this.basicParams.length > 1
      const type = this.basicParams[0]?.type
      return this.findItemByType(type, multiple)
    },
    /**
     * @description 用來渲染表格的資料(包含優惠券)
     */
    servicesList() {
      const services = cloneDeep(this.serviceItem)

      if (this.hasCouponInfo) {
        services.splice(1, 0, this.defaultCoupon)
        return services
      }

      return services
    },
    prepaidPlanItem() {
      // 購買包月
      return this.findItemByType('prepaid-plan')
    },
    prepaidDeductItem() {
      // 包月抵扣
      return this.findItemByType('prepaid')
    },
    couponItem() {
      return this.defaultCoupon
    },
    depositPlanItem() {
      return this.findItemByType('deposit-plan')
    },
    goodsPriceTotal() {
      return this.basicParams.reduce((acc, cur) => acc + cur.prices?.[0].price * cur.qty, 0)
    },
    depositPlanItemPoint() {
      return this.isOrderCreated ? this.depositPlanItem.bonus + this.depositPlanItem.point : this.depositPlanItem.point
    },
    hasDepositPlanItem() {
      return this.depositPlanItem.title !== '' && this.depositPlanItem.title !== undefined
    },
    params() {
      return this.submitData.params.filter(({ type }) => this[`${this.orderType}Types`].includes(type))
    },
    hasCouponInfo() {
      return Object.keys(this.couponItem).length > 0
    },
    couponPriceTotal() {
      const sum = this.serviceItem.reduce((acc, cur) => acc + cur.price * cur.qty, 0) || this.serviceItem.total

      if (this.isOrderCreated && this.serviceItem[0].priceId) {
        if (!this.hasCouponInfo) return sum
      }
      // 決定此次會員等級折扣
      let currentMemberLevelDiscount = this.decideCurrentMemberDiscount()
      // 如果沒有Coupon & memberLevelDiscount === 0
      if (!this.hasCouponInfo && this.memberLevelDiscount === 0) {
        let result = 0
        if (this.orderType === 'goods') {
          result = this.goodsPriceTotal
          return
        }
        result = sum - Math.round(sum * (currentMemberLevelDiscount / 100)) ?? this.serviceItem.total - Math.round(this.serviceItem.total * (currentMemberLevelDiscount / 100))
        return result < 0 ? 0 : result
      }
      // 如果沒有Coupon & memberLevelDiscount === '%'
      if (!this.hasCouponInfo && this.memberLevelDiscount.discountType === '%') {
        const result = sum - Math.round(sum * currentMemberLevelDiscount) ?? this.serviceItem.total - Math.round(this.serviceItem.total * (currentMemberLevelDiscount / 100))
        return result < 0 ? 0 : result
      }
      // 如果沒有Coupon & memberLevelDiscount === 'fixed'
      if (!this.hasCouponInfo && this.memberLevelDiscount.discountType === 'fixed') {
        const fixNum =
          Array.isArray(this.serviceItem) && this.serviceItem.length
            ? this.serviceItem.reduce((acc, cur) => acc + (cur.price - Math.round(currentMemberLevelDiscount)) * cur.qty, 0)
            : this.serviceItem.qty * currentMemberLevelDiscount
        const result = sum - Math.round(fixNum) ?? this.serviceItem.qty * (this.serviceItem.price - Math.round(currentMemberLevelDiscount))
        return result < 0 ? 0 : result
      }
      if (!this.hasCouponInfo && !currentMemberLevelDiscount && Array.isArray(this.memberLevelDiscount)) {
        return this.serviceItem.reduce((acc, cur) => {
          const currentDiscount = this.memberLevelDiscount.find((discount) => discount.id === cur.priceId)

          if (!currentDiscount) return acc + cur.price * cur.qty

          const currentNum = currentDiscount.discountType === '%' ? cur.price * cur.qty * (1 - parseInt(currentDiscount.discount) / 100) : (cur.price - parseInt(currentDiscount.discount)) * cur.qty

          return acc + currentNum
        }, 0)
      }
      let basePriceTotal = this.serviceItem.price ?? sum ?? this.goodsPriceTotal
      if (this.isOrderCreated && this.serviceItem.id) {
        basePriceTotal = this.serviceItem.total
      } else if (Array.isArray(this.serviceItem) && Array.isArray(this.memberLevelDiscount)) {
        // basePriceTotal = this.serviceItem.reduce((acc, cur) => {
        //   const currentDiscount = this.memberLevelDiscount.find((discount) => discount.id === cur.priceId)
        //   const currentNum = currentDiscount.discountType === '%' ? cur.price * cur.qty * (1 - parseInt(currentDiscount.discount) / 100) : (cur.price - parseInt(currentDiscount.discount)) * cur.qty

        //   return acc + currentNum
        // }, 0)
        basePriceTotal = this.serviceItem.map((service) => {
          const currentDiscount = this.memberLevelDiscount.find((discount) => discount.id === service.priceId)

          if (!currentDiscount) return service.price
          return currentDiscount.discountType === '%'
            ? service.price * service.qty * (1 - parseInt(currentDiscount.discount) / 100)
            : (service.price - parseInt(currentDiscount.discount)) * service.qty
        })
      } else {
        let discountNum = this.decideDiscountNum(currentMemberLevelDiscount)
        discountNum = discountNum < 0 ? 0 : discountNum // 會員的折扣
        basePriceTotal = this.orderType !== 'goods' ? (this.serviceItem.price || sum) - Math.round(discountNum) : this.goodsPriceTotal - Math.round(discountNum) // 服務價錢-> 再減掉會員折扣
        basePriceTotal = basePriceTotal < 0 ? 0 : basePriceTotal // 減掉之後，最小就是0
      }

      const { discount, type, description, introtext } = this.couponItem
      const couponDiscount = discount ?? description
      const couponType = ['fixed', '%'].includes(type) ? type : introtext

      const couponComputed = (value, total, service) => {
        console.log(total)
        if (Array.isArray(total) && total.length) {
          if (couponType === 'fixed') {
            const sum = total.reduce((acc, cur) => acc + cur, 0)
            return sum - value < 0 ? 0 : sum - value
          }

          let num = 0
          total.forEach((price, index) => {
            index === 0 ? (num += price - Math.round((price * value) / 100)) : (num += price)
          })

          return num
        } else {
          return couponType === 'fixed' ? (total - value < 0 ? 0 : total - value) : total - Math.round(total * (value / 100))
        }
      }

      return couponComputed(couponDiscount, basePriceTotal, this.serviceItem)
    },
    /**
     * @description 應付金額
     */
    submitPriceTotal() {
      try {
        let total = 0
        const memberLevelPercent = this.memberLevelDiscount
        switch (this.orderType) {
          case 'reservation':
            total = this.couponPriceTotal || 0
            break
          case 'goods':
            total = this.couponPriceTotal || this.goodsPriceTotal
          case 'prepaid':
            if (Object.keys(this.prepaidPlanItem).length > 0 && this.prepaidPlanItem.price > 0) {
              total = this.composeTotalForDiscountObj({
                price: this.prepaidPlanItem.price || 0,
                discountType: memberLevelPercent['discountType'] || 'fixed',
                discount: memberLevelPercent['discount'] || 0,
              })
            }
            break
          case 'deposit':
            if (Object.keys(this.depositPlanItem).length > 0 && this.depositPlanItem.price > 0) {
              total = this.composeTotalForDiscountObj({
                price: this.depositPlanItem.price || 0,
                discountType: memberLevelPercent['discountType'] || 'fixed',
                discount: memberLevelPercent['discount'] || 0,
              })
            }
            break
        }
        if (this.orderType === 'reservation') {
          if (this.isOrderCreated) {
            if (this.prepaidDeductItem.priceId) {
              total = 0
            }
          } else {
            if (this.submitData.prepaidOrderUuid || this.buyingPrepaidInfo.prepaidId) {
              total = 0
            }
          }
        }
        total = calcTotal({ price: total, totalEditList: this.totalEditParams, memberLevelPercent, memberInfo: this.memberInfo })
        this.$store.commit('cart/UPDATE_TOTALPRICE', total)
        this.$nextTick(() => {
          this.$forceUpdate()
        })
        return total
      } catch (error) {
        console.error(error.message)
      }
    },
    serviceTotal() {
      let total = 0
      // 使用儲值金返回0元
      if (this.prepaidDeductItem.priceId) {
        return total
      }
      // 有優惠券使用couponPriceTotal
      if (this.hasCouponInfo) {
        return this.couponPriceTotal
      }
      // 服務或商品總價計算
      if (Array.isArray(this.serviceItem) && this.serviceItem.length) {
        total = this.serviceItem.reduce((acc, cur) => acc + cur.price, 0)
      } else if (this.serviceItem.total) {
        total = this.serviceItem.total
      }

      return total
    },
    // 未包含加減價或優惠券的原始訂單價格
    basicPriceTotal() {
      return this.basicParams.reduce((acc, cur) => {
        // if (Array.isArray(this.memberLevelDiscount) && this.memberLevelDiscount.length) {
        //   const currentDiscount = this.memberLevelDiscount.find((discount) => discount.id === cur.priceId)

        //   if (currentDiscount) {
        //     const currentPrice = currentDiscount.discountType === '%'
        //     ? cur.price * cur.qty * (1 - parseInt(currentDiscount.discount) / 100)
        //     : (cur.price - parseInt(currentDiscount.discount)) * cur.qty

        //     return acc + currentPrice
        //   }
        // }

        return acc + cur.price * cur.qty
      }, 0)
    },
    memberLevelDiscount() {
      if (this.orderType === 'prepaid') {
        return this.composeMemberLevelDiscount(this.prepaidPlanItem)
      }
      if (this.orderType === 'reservation') {
        return this.composeMemberLevelDiscount(this.serviceItem)
      }
      if (this.orderType === 'deposit') {
        return this.composeMemberLevelDiscount(this.depositPlanItem)
      }
      if (this.orderType === 'goods') {
        return this.composeMemberLevelDiscount(this.basicParams)
      }
    },
  },
  watch: {
    defaultValue: {
      handler() {
        this.submitData = cloneDeep(this.defaultValue)
        console.log('🚀 ~ file: TotalStatement.vue:285 ~ handler ~ this.submitData:', this.submitData)
        this.basicParams = this.defaultValue.params.filter(({ type }) => !this[`${this.orderType}Types`].includes(type))
        this.totalEditParams = this.defaultValue.params.filter(({ type }) => this[`${this.orderType}Types`].includes(type))
        if (this.orderType === 'goods') {
          this.$store.commit('cart/UPDATE_CART', this.basicParams)
          this.$store.commit('cart/CHANGE_PRICE', this.totalEditParams)
        }
      },
      immediate: true,
      deep: true,
    },
    defaultCoupon: {
      handler(nvl) {
        this.$store.commit('cart/UPDATE_COUPON', cloneDeep(nvl))
      },
    },
  },
  methods: {
    /**
     * @description 刪除商品
     */
    handleRemoveGoods(goodItem) {
      this.$emit('handleRemoveGoods', goodItem)
    },
    /**
     * @description 更改數量
     */
    changeNum(goodItem, type) {
      if (type === 'add') {
        let addNum = goodItem.qty + 1
        this.$set(goodItem, 'qty', addNum)
      }
      if (type === 'delete') {
        let deleteNum = goodItem.qty - 1
        if (deleteNum < 1) {
          this.$message.error('數量不得小於1')
          return
        }
        this.$set(goodItem, 'qty', deleteNum)
      }
    },
    /**
     * @description 規格敘述
     */
    descriptionForGoods(goodItem) {
      const specArr = []
      goodItem.spec.forEach((item) => {
        specArr.push(`${item.title}: ${item.values[0].title}`)
      })
      return specArr.join(' | ')
    },
    /**
     * @description 決定會員等級折扣要折多少錢
     */
    decideDiscountNum(currentMemberLevelDiscount) {
      try {
        if (!this.memberLevelDiscount.discountType) {
          // 如果undefined or 0，則直接return 0
          return 0
        } else {
          return this.memberLevelDiscount.discountType === '%' ? this.serviceItem.price * (currentMemberLevelDiscount / 100) : this.serviceItem.price - currentMemberLevelDiscount
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 決定此次會員等級折扣為什麼樣的型態
     */
    decideCurrentMemberDiscount() {
      try {
        // 取得會員Discount === '%'
        if (this.memberLevelDiscount.discountType === '%') {
          return parseInt(this.memberLevelDiscount.discount) / 100
        }
        // 取得會員Discount === 'fixed'
        if (this.memberLevelDiscount.discountType === 'fixed') {
          return parseInt(this.memberLevelDiscount.discount)
        }
        // 取得會員Discount === '0'
        if (this.memberLevelDiscount === 0) {
          return 0
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 計算購買包月的價錢
     * @param {@} item
     */
    compPriceForBuyingPrepaidInfo(item) {
      try {
        const prepaids = this.memberInfo?.level?.prepaids
        if (Array.isArray(prepaids)) {
          const index = prepaids.findIndex((prepaidItem) => prepaidItem.id === item.prepaidId)
          if (index > -1) {
            return this.composeTotalForDiscountObj({
              price: item.price,
              discountType: prepaids[index]['discountType'],
              discount: prepaids[index]['discount'],
            })
          } else {
            return item.price
          }
        }
        return item.price
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description child 的 item是否有等級折價
     * @param {} childItem
     */
    isChildOrdersHasLevel(childItem) {
      try {
        let discountIndex = -1
        const servicePrices = this.memberInfo?.level?.servicePrices
        if (Array.isArray(servicePrices)) {
          discountIndex = servicePrices.findIndex((item) => item.id === childItem.priceId && parseInt(item.discount) > 0)
        }
        return discountIndex
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 是否要顯示垃圾桶
     */
    showStatus(item) {
      return true
      if (item && item.moreType && item.moreType === 'offTime') {
        return false
      } else {
        return true
      }
    },
    findItemByType(itemType = '', multiple = false) {
      // 更新參數，丟給父組件
      this.$emit('updateParam', this.getFilterParams())

      // 過濾符合條件的項目
      const filteredItems = this.defaultValue.params.filter(({ type }) => type === itemType)

      if (itemType === 'cosmetic' || itemType === 'goods') {
        return filteredItems
      } else {
        return filteredItems.length ? filteredItems[0] : {}
      }
    },
    getFilterParams() {
      try {
        return {
          basicParams: this.defaultValue.params.filter(({ type }) => !this[`${this.orderType}Types`].includes(type)),
          params: this.defaultValue.params.filter(({ type }) => this[`${this.orderType}Types`].includes(type)),
          deleteIds: [...this.deleteIds],
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    formatParamTitle(paramItem) {
      const paramType = paramItem.type
      const note = paramItem.title ? `<br/>(${paramItem.title})` : ''

      switch (paramType) {
        case 'cosmetic-add':
          return `加購「${paramItem.title}」`
        case '+':
          return `加價${note}`
        case '-':
          return `減價${note}`
        case '%':
          return `折扣${note}`
        case 'express':
          return `運費${note}`
        default:
          return paramItem.title
      }
    },
    formatParamPrice(paramItem) {
      const paramType = paramItem.type
      const cosmeticAddItem = paramItem.type === 'cosmetic-add' ? paramItem : {}
      switch (paramType) {
        case '+':
        case 'express':
          return `+${paramItem.price}`
        case '-':
        case 'deposit':
          return `-${paramItem.price}`
        case '%':
          return `-${Math.abs(paramItem.discount)}`
        default:
          return this.formatMemberLevelPrice({ price: paramItem.price * paramItem.qty, totalStatus: true, cosmeticAddItem })
      }
    },
    /**
     * @description 清除params
     */
    deleteParamItem(item, index) {
      try {
        if (item.moreType && item.moreType === 'offTime') {
          this.$emit('deleteOffTime')
        }
        if (item.id) this.deleteIds.push(item.id)
        this.totalEditParams.splice(index, 1)
        this.emitUpdate()
      } catch (error) {
        console.error(error.message)
      }
    },
    emitUpdate() {
      this.$emit('update', {
        params: [...this.totalEditParams],
        deleteIds: [...this.deleteIds],
      })
    },
    openAddEdit() {
      this.$emit('openAdd')
    },
    openChangeEdit() {
      this.$emit('openChange')
    },
    openTotalEdit() {
      this.$emit('openTotalEdit')
    },
    /**
     * @description 會員價的單價計算
     */
    memberPrice(item) {
      return item.price - item.levelDiscountValue / item.qty
    },
    /**
     * @description 修改時的會員價顯示（總計
     * @param {@} param0
     */
    formatMemberLevelPriceForEdit({ price, totalStatus = false, cosmeticAddItem = {}, serviceItem }) {
      // serviceItem.levelDiscount > 0 代表有可能已經是修改模式
      if (serviceItem.levelDiscount > 0) {
        return (serviceItem.price - serviceItem.levelDiscountValue / serviceItem.qty) * serviceItem.qty
      } else {
        return this.formatMemberLevelPrice({
          price: serviceItem.price * serviceItem.qty,
          totalStatus: true,
        })
      }
    },
    /**
     * @description 計算會員價(分為總計or個別)
     * @param {*} price 會員價格
     * @param {*} totalStatus 是否是總計部分（總記要多加qty）
     * @param {*} cosmeticAddItem 是否為加購
     */
    formatMemberLevelPrice({ price, totalStatus = false, cosmeticAddItem = {} }) {
      try {
        let item = {
          prepaid: this.prepaidPlanItem,
          reservation: this.serviceItem,
          deposit: this.depositPlanItem,
        }
        if (Object.keys(cosmeticAddItem).length > 0) {
          const servicePrices = this.memberInfo?.level?.servicePrices || []
          const serviceIndex = servicePrices.findIndex((item) => item.id === cosmeticAddItem.priceId)
          if (serviceIndex > -1) {
            let delNum =
              servicePrices[serviceIndex].discountType === '%'
                ? price - price * (parseInt(servicePrices[serviceIndex].discount) / 100)
                : price - parseInt(servicePrices[serviceIndex].discount) * (totalStatus ? cosmeticAddItem.qty : 1)
            delNum = delNum < 0 ? 0 : delNum
            return delNum
          } else {
            return price
          }
        } else {
          if (Object.keys(item[this.orderType]).length === 0 || !item[this.orderType]) {
            return 0
          }
          if (this.memberLevelDiscount === 0) {
            return price - Math.round(price * (this.memberLevelDiscount / 100))
          }
          if (Array.isArray(item[this.orderType]) && item[this.orderType].length) {
            if (Object.keys(price).length) {
              const discountData = this.memberLevelDiscount.find((discount) => discount.id === price.priceId)
              if (!totalStatus) {
                return discountData.discountType === '%' ? price.price * (1 - parseInt(discountData.discount) / 100) : price.price - parseInt(discountData.discount)
              }
              return discountData.discountType === '%' ? price.price * (1 - parseInt(discountData.discount) / 100) * price.qty : price.price - parseInt(discountData.discount) * price.qty
            } else {
              return item[this.orderType].reduce((acc, cur) => {
                const currentDiscount = this.memberLevelDiscount.find((discount) => discount.id === cur.priceId)
                if (currentDiscount) {
                  const currentPrice =
                    currentDiscount.discountType === '%' ? cur.price * cur.qty * (1 - parseInt(currentDiscount.discount) / 100) : (cur.price - parseInt(currentDiscount.discount)) * cur.qty

                  return acc + currentPrice
                }
              }, 0)
            }
          }
          let delNum =
            this.memberLevelDiscount.discountType === '%'
              ? price - price * (parseInt(this.memberLevelDiscount.discount) / 100)
              : price - parseInt(this.memberLevelDiscount.discount) * (totalStatus ? item[this.orderType].qty : 1)
          delNum = delNum < 0 ? 0 : delNum
          return delNum
        }
      } catch (error) {
        console.error(error.message)
      }
    },
  },
}
</script>
<template>
  <div :class="{ [$style.wrapper]: orderType !== 'goods', [$style.wrapperForGoods]: orderType === 'goods' }">
    <div :class="{ [$style.table]: true, [$style.goodsTable]: orderType === 'goods' }">
      <div class="d-flex justify-content-between mb-2">
        <h6 v-if="orderType !== 'goods'">訂單計算</h6>
        <template v-if="orderType === 'reservation' && enabledAddition">
          <el-button type="primary" class="is-round" :class="isEmployee ? 'd-md-none' : 'd-none'" @click="openChangeEdit">編輯變價</el-button>
          <el-button type="primary" class="is-round" :disabled="containerEdit" @click="openAddEdit">編輯加購</el-button>
        </template>
      </div>
      <div class="mb-5" :class="{ table__scroll: orderType !== 'goods', table__goodsScroll: orderType === 'goods' }">
        <!-- 預約 -->
        <template v-if="orderType === 'reservation'">
          <div class="table__block">
            <template v-if="!isChildrenOrderCreating">
              <template v-if="buyingPrepaidInfo.prepaidId">
                <div class="table__head">
                  <div class="table__title"> 購買{{ `${$t('prepaid.BASE')} ` }} </div>
                  <div class="table__single"> 售價 </div>
                  <div class="table__button"> </div>
                </div>
                <div class="table__box" style="margin-bottom: 20px">
                  <div class="table__row">
                    <div class="table__title" style="width: 60%"> {{ buyingPrepaidInfo.title }} </div>
                    <div class="table__single" style="width: 30%">
                      <template v-if="memberInfo.level && buyingPrepaidInfoDiscountIndex > -1">
                        <span style="display:none">TotalStatement C</span>會員價：{{ prepaidInfoLevelDiscountPrice }} <br />
                        <del class="line-through-price">售價：{{ buyingPrepaidInfo.price }}</del>
                      </template>
                      <template v-else>
                        {{ buyingPrepaidInfo.price }}
                      </template>
                    </div>
                    <div class="table__button"> </div>
                  </div>
                </div>
              </template>
            </template>
            <div class="table__head">
              <div class="table__title"><span style="display: none">TotalStatement A</span>預約項目</div>
              <div class="table__item price">售價</div>
              <div class="table__item qty">數量</div>
              <div class="table__item count">小計</div>
              <div class="table__button"></div>
            </div>
            <template v-if="!isChildrenOrderCreating">
              <!-- 新增母訂單 -->
              <template v-if="isOrderCreated">
                <!-- <div v-if="serviceItem.priceId" class="table__box mb-3">
                  <div class="table__row">
                    <div class="table__title">{{ serviceItem.title }}</div>
                    <div class="table__item price">
                      <template v-if="serviceItem.levelDiscount > 0">
                        <span style="display:none">TotalStatement D</span>會員價： {{ memberPrice(serviceItem) }}
                        <br />
                        <del class="line-through-price">售價：{{ serviceItem.price }}</del>
                      </template>
                      <template v-else>
                        {{ serviceItem.price }}
                      </template>
                    </div>
                    <div class="table__item qty">{{ `x${serviceItem.qty} ` }}</div>

                    <div v-if="serviceItem.priceId === 'fake'" class="table__item count">
                      {{ serviceItem.total }}
                    </div>

                    <div v-if="serviceItem.priceId !== 'fake'" class="table__item count">
                      {{
                        isHasLevel
                          ? formatMemberLevelPriceForEdit({
                              price: serviceItem.price * serviceItem.qty,
                              totalStatus: true,
                              serviceItem: serviceItem,
                            })
                          : (serviceItem.price - serviceItem.levelDiscountValue / serviceItem.qty) * serviceItem.qty
                      }}
                    </div>
                    <div class="table__button"> </div>
                  </div>

                  <div v-if="prepaidDeductItem.priceId" class="table__row">
                    <div class="table__title">{{ prepaidDeductItem.title }}</div>
                    <div class="table__single">{{ prepaidDeductItem.total }}</div>
                    <div class="table__button"> </div>
                  </div>

                  <div v-if="hasCouponInfo" class="table__row">
                    <div class="table__title">{{ `優惠券(${couponItem.code})` }}</div>
                    <div class="table__single">
                      {{ couponPriceTotal - serviceItem.total }}
                    </div>
                    <div class="table__button"> </div>
                  </div>

                  <div class="table__row">
                    <div class="table__title">小計</div>
                    <div class="table__single">{{ serviceTotal }}</div>
                    <div class="table__button"> </div>
                  </div>
                </div> -->
                <div v-if="servicesList.length && servicesList[0].priceId" class="table__box mb-3">
                  <div class="table__row" v-for="service in servicesList" :key="service.id">
                    <div class="table__title">{{ service.code ? `優惠券(${service.code})` : service.title }}</div>
                    <div class="table__item price">
                      <template v-if="service.levelDiscount > 0">
                        <span style="display:none">TotalStatement D</span>會員價： {{ memberPrice(service) }}
                        <br />
                        <del class="line-through-price">售價：{{ service.price }}</del>
                      </template>
                      <template v-else>
                        {{ service.price }}
                      </template>
                    </div>
                    <div class="table__item qty">{{ service.code ? '' : `x${service.qty} ` }}</div>

                    <div v-if="service.priceId && service.priceId === 'fake'" class="table__item count">
                      {{ service.total }}
                    </div>

                    <div v-if="service.priceId && service.priceId !== 'fake'" class="table__item count">
                      {{
                        isHasLevel
                          ? formatMemberLevelPriceForEdit({
                              price: service.price * service.qty,
                              totalStatus: true,
                              serviceItem: service,
                            })
                          : (service.price - service.levelDiscountValue / service.qty) * service.qty
                      }}
                    </div>
                    <div v-if="service.code" class="table__item count">{{ couponPriceTotal - (isHasLevel && memberInfo.level.servicePrices && memberInfo.level.servicePrices.length ? formatMemberLevelPrice({ price: basicPriceTotal }) : basicPriceTotal) }}</div>
                    <div class="table__button"> </div>
                  </div>

                  <div v-if="prepaidDeductItem.priceId" class="table__row">
                    <div class="table__title">{{ prepaidDeductItem.title }}</div>
                    <div class="table__single">{{ prepaidDeductItem.total }}</div>
                    <div class="table__button"> </div>
                  </div>

                  <!-- <div v-if="hasCouponInfo" class="table__row">
                    <div class="table__title">{{ `優惠券(${couponItem.code})` }}</div>
                    <div class="table__single">
                      {{ couponPriceTotal - basicPriceTotal }}
                    </div>
                    <div class="table__button"> </div>
                  </div> -->

                  <div class="table__row">
                    <div class="table__title">小計</div>
                    <div class="table__single">{{ serviceTotal }}</div>
                    <div class="table__button"> </div>
                  </div>
                </div>
              </template>
              <!-- 編輯母訂單 -->
              <template v-else>
                <!-- <div v-if="serviceItem.priceId" class="table__box mb-3">
                  <div class="table__row">
                    <div class="table__title">{{ serviceItem.title }}</div>
                    <div class="table__item price">
                      <template v-if="isHasLevel">
                        <span style="display:none">TotalStatement E</span>會員價：
                        {{
                          formatMemberLevelPrice({
                            price: serviceItem.price,
                          })
                        }}
                        <br />
                        <del class="line-through-price">售價：{{ serviceItem.price }}</del>
                      </template>
                      <template v-else>
                        {{ serviceItem.price }}
                      </template>
                    </div>
                    <div class="table__item qty">{{ `x${serviceItem.qty} ` }}</div>
                    <div class="table__item count">
                      {{
                        isHasLevel
                          ? formatMemberLevelPrice({
                              price: serviceItem.price * serviceItem.qty,
                              totalStatus: true,
                            })
                          : serviceItem.price * serviceItem.qty
                      }}
                    </div>
                    <div class="table__button"> </div>
                  </div>

                  <div v-if="submitData.prepaidOrderUuid || buyingPrepaidInfo.prepaidId" class="table__row">
                    <div class="table__title">{{ `${$t('prepaid.BASE')} 抵扣` }}</div>
                    <div class="table__single">{{ `- ${isHasLevel ? formatMemberLevelPrice({ price: serviceItem.price }) : serviceItem.price} ` }}</div>
                    <div class="table__button"> </div>
                  </div>

                  <div v-if="hasCouponInfo" class="table__row">
                    <div class="table__title">{{ `優惠券(${couponItem.code})` }}</div>
                    <div class="table__single">
                      {{ couponPriceTotal - (isHasLevel && memberInfo.level.discount && memberInfo.level.discount.cosmetic ? formatMemberLevelPrice({ price: serviceItem.price }) : serviceItem.price) }}
                    </div>
                    <div class="table__button"> </div>
                  </div>

                  <div class="table__row">
                    <div class="table__title">小計</div>
                    <div class="table__single">{{ submitData.prepaidOrderUuid || buyingPrepaidInfo.prepaidId ? 0 : couponPriceTotal }}</div>
                    <div class="table__button"> </div>
                  </div>
                </div> -->
                <div v-if="servicesList.length && servicesList[0].priceId" class="table__box mb-3">
                  <div v-for="item in servicesList" :key="item.priceId" class="table__row">
                    <div class="table__title">{{ item.code ? `優惠券(${couponItem.code})` : item.title }}</div>
                    <div class="table__item price">
                      <template v-if="isHasLevel && !item.code">
                        <span style="display:none">TotalStatement E</span>會員價：
                        {{
                          formatMemberLevelPrice({
                            price: item,
                          })
                        }}
                        <br />
                        <del class="line-through-price">售價：{{ item.price }}</del>
                      </template>
                      <template v-else>
                        {{ item.code ? '' : item.price }}
                      </template>
                    </div>
                    <div class="table__item qty">{{ item.code ? '' : `x${item.qty} ` }}</div>
                    <template>
                      <div v-if="!item.code" class="table__item count">
                        {{
                          isHasLevel
                            ? formatMemberLevelPrice({
                                price: item,
                                totalStatus: true,
                              })
                            : item.price * item.qty
                        }}
                      </div>
                      <div v-else class="table__item count">
                        {{ couponPriceTotal - (isHasLevel && memberInfo.level.servicePrices && memberInfo.level.servicePrices.length ? formatMemberLevelPrice({ price: basicPriceTotal }) : basicPriceTotal) }}
                      </div>
                    </template>
                    <div class="table__button"> </div>
                  </div>

                  <div v-if="submitData.prepaidOrderUuid || buyingPrepaidInfo.prepaidId" class="table__row">
                    <div class="table__title">{{ `${$t('prepaid.BASE')} 抵扣` }}</div>
                    <div class="table__single">{{ `- ${isHasLevel ? formatMemberLevelPrice({ price: servicesList[0].price }) : servicesList[0].price} ` }}</div>
                    <div class="table__button"> </div>
                  </div>

                  <div class="table__row">
                    <div class="table__title">小計</div>
                    <div class="table__single">{{ submitData.prepaidOrderUuid || buyingPrepaidInfo.prepaidId ? 0 : couponPriceTotal }}</div>
                    <div class="table__button"> </div>
                  </div>
                </div>
              </template>
            </template>
            <!-- 加購/變價 -->
            <!-- <template v-if="orderType === 'reservation' && enabledAddition && !isChildrenOrderCreating"> </template> -->
            <template v-if="totalEditParams.length > 0">
              <div class="table__box" :class="{ isHasLevel: isHasLevel }">
                <div v-for="(item, index) in totalEditParams" :key="index" class="table__row">
                  <div class="table__title">
                    <span v-html="formatParamTitle(item)"></span>
                  </div>
                  <!-- 加購 -->
                  <template v-if="item.id !== undefined">
                    <div class="table__item price">
                      <template v-if="item.type === 'cosmetic-add' && item.levelDiscount > 0">
                        <span style="display:none">TotalStatement F</span>會員價： {{ Math.floor(item.price - item.levelDiscountValue / item.qty) }}
                        <br />
                        <del class="line-through-price">售價：{{ item.price }}</del>
                      </template>
                      <span v-else>{{ item.type === '%' ? `${item.description} % ` : item.price }}</span>
                    </div>
                    <div class="table__item qty">x{{ item.qty }}</div>
                    <div class="table__item count">{{ item.type === '%' ? formatParamPrice(item) : Math.floor(item.total) }}</div>
                  </template>
                  <!-- 加減價/折扣/運費 -->
                  <template v-else>
                    <div class="table__item price" :class="{ isHasLevelItem: isHasLevel }">
                      <template v-if="isChildOrdersHasLevel(item, 'services') > -1 && item.type === 'cosmetic-add' && !!item.price">
                        <span style="display:none">TotalStatement G</span>會員價：
                        {{
                          formatMemberLevelPrice({
                            price: item.price,
                            totalStatus: false,
                            cosmeticAddItem: item,
                          })
                        }}
                        <br />
                        <del class="line-through-price">售價：{{ item.price }}</del>
                      </template>
                      <template v-else>
                        {{ item.type === '%' ? `${item.price} % ` : item.price }}
                      </template>
                    </div>
                    <div class="table__item qty">{{ `x${item.qty} ` }}</div>
                    <div class="table__item count">{{ formatParamPrice(item) }}</div>
                  </template>
                  <div class="table__button">
                    <div v-if="enabledEdit && showStatus(item)" @click="deleteParamItem(item, index)">
                      <BaseIcon name="trash-alt" class="isStyleSecondary"></BaseIcon>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div class="table__box" style="margin-top: 10px">
              <div class="table__row">
                <div class="table__title"> 應付金額<span style="display:none">TotalStatement 2A</span> </div>
                <div class="table__single">
                  <span v-if="buyingPrepaidInfo.prepaidId">
                    <template v-if="memberInfo.level && memberInfo.level.prepaids && memberInfo.level.prepaids.length > 0">
                      {{ compPriceForBuyingPrepaidInfo(buyingPrepaidInfo) }}
                    </template>
                    <template v-else>
                      {{ buyingPrepaidInfo.price }}
                    </template>
                    +
                  </span>
                  {{ submitPriceTotal }}
                </div>
                <div class="table__button"> </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 包月 -->
        <template v-if="orderType === 'prepaid'">
          <div class="table__block">
            <div class="table__head">
              <div class="table__title">項目<span style="display:none">TotalStatement 3A</span></div>
              <div class="table__item price">售價</div>
              <div class="table__item qty">數量</div>
              <div class="table__item count">小計</div>
              <div class="table__button"></div>
            </div>

            <div class="table__box">
              <!-- 包月-create mode -->
              <template v-if="isOrderCreated">
                <template v-if="prepaidPlanItem.priceId" class="table__box">
                  <div class="table__row">
                    <div class="table__title">{{ prepaidPlanItem.title }}</div>
                    <div class="table__item price">
                      <template v-if="isHasLevel && (prepaidPlanItem.price || prepaidPlanItem.total)">
                        <span style="display:none">TotalStatement H</span>會員價： {{ prepaidPlanItem.price }}
                        <br />
                        <del class="line-through-price">售價：{{ prepaidPlanItem.price }}</del>
                      </template>
                      <template v-else>
                        {{ prepaidPlanItem.price }}
                      </template>
                    </div>
                    <div class="table__item qty">{{ `x${prepaidPlanItem.qty} ` }}</div>
                    <div class="table__item count">{{ prepaidPlanItem.total * prepaidPlanItem.qty }}</div>
                    <div class="table__button"> </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <!-- 主要包月項目 -->
                <template v-if="prepaidPlanItem.priceId" class="table__box">
                  <div class="table__row">
                    <div class="table__title">{{ prepaidPlanItem.title }}</div>
                    <div class="table__item price">
                      <template v-if="isHasLevel && (prepaidPlanItem.price || prepaidPlanItem.total)">
                        <span style="display:none">TotalStatement I</span>會員價：
                        {{
                          formatMemberLevelPrice({
                            price: prepaidPlanItem.price,
                          })
                        }}
                        <br />
                        <del class="line-through-price">售價：{{ prepaidPlanItem.price }}</del>
                      </template>
                      <template v-else>
                        {{ prepaidPlanItem.price }}
                      </template>
                    </div>
                    <div class="table__item qty">{{ `x${MaxQty} ` }}</div>
                    <div class="table__item count">
                      {{ isHasLevel ? formatMemberLevelPrice({ price: prepaidPlanItem.price * MaxQty, totalStatus: true }) : prepaidPlanItem.price * MaxQty }}
                    </div>
                    <div class="table__button"> </div>
                  </div>
                </template>
              </template>

              <template v-if="totalEditParams.length > 0">
                <div v-for="(item, index) in totalEditParams" :key="index" class="table__row">
                  <div class="table__title">
                    <span v-html="formatParamTitle(item)"></span>
                  </div>
                  <template v-if="item.id !== undefined">
                    <div class="table__item price">
                      <span>{{ item.type === '%' ? `${item.description} % ` : item.total }}</span>
                    </div>
                    <div class="table__item qty">{{ 'x1' }}</div>
                    <div class="table__item count">{{ item.type === '%' ? formatParamPrice(item) : item.total }}</div>
                  </template>
                  <template v-else>
                    <div class="table__item price">{{ item.type === '%' ? `${item.price} % ` : item.price }}</div>
                    <div class="table__item qty">{{ 'x1' }}</div>
                    <div class="table__item count">{{ formatParamPrice(item) }}</div>
                  </template>
                  <div class="table__button">
                    <div v-if="enabledEdit && showStatus(item)" @click="deleteParamItem(item, index)">
                      <BaseIcon name="trash-alt"></BaseIcon>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="table__box" style="margin-top: 10px">
              <div class="table__row">
                <div class="table__title"> <span style="display:none">TotalStatement 2B</span>應付金額 </div>
                <div class="table__single">{{ submitPriceTotal }}</div>
                <div class="table__button"> </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 儲值金 -->
        <template v-if="orderType === 'deposit'">
          <div class="table__block">
            <div class="table__head">
              <div class="table__title">項目<span style="display:none">TotalStatement 3B</span></div>
              <div v-if="orderSecondType === 'deposit'" class="table__item count">點數</div>
              <div class="table__item qty">數量</div>
              <div class="table__item price">小計</div>
            </div>

            <div class="table__box">
              <template v-if="hasDepositPlanItem" class="table__box">
                <div class="table__row">
                  <div class="table__title">{{ depositPlanItem.title }}</div>
                  <div v-if="orderSecondType === 'deposit'" class="table__item count">{{ depositPlanItem.point }}</div>
                  <div class="table__item qty">{{ `x${depositPlanItem.qty} ` }}</div>
                  <div class="table__item price">
                    <template v-if="isHasLevel && (depositPlanItem.price || depositPlanItem.total)">
                      <span style="display:none">TotalStatement B</span>會員價：
                      {{
                        formatMemberLevelPrice({
                          price: depositPlanItem.price,
                        })
                      }}
                      <br />
                      <del class="line-through-price">售價：{{ depositPlanItem.total || depositPlanItem.price }}</del>
                    </template>
                    <template v-else>
                      {{ depositPlanItem.total || depositPlanItem.price }}
                    </template>
                  </div>
                </div>
              </template>
            </div>

            <div class="table__box" style="margin-top: 10px">
              <div v-if="orderSecondType === 'deposit'" class="table__row">
                <div class="table__title"> <span style="display:none">TotalStatement 2C</span>應付金額 </div>
                <div class="table__single">{{ submitPriceTotal }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 商品 -->
        <template v-if="orderType === 'goods'">
          <div class="table__block">
            <div class="table__head">
              <div class="table__title" style="width: 40%;">項目/售價<span style="display:none">TotalStatement 3gB</span> </div>
              <div class="table__item qty" style="display: flex; justify-content: center;width: 30%;">數量</div>
              <div class="table__item price" style="display: flex; justify-content: end;width: 20%;">小計</div>
              <div class="table__item price" style="display: flex; justify-content: center;width: 10%;"></div>
            </div>

            <div class="table__box">
              <template v-if="basicParams.length > 0" class="table__box">
                <template v-for="(goodsItem, goodsIndex) in basicParams">
                  <div :key="goodsIndex" class="table__row" :class="$style.goodsItem">
                    <div class="table__title" :class="$style.goodsItem__titleRegion" style="width: 45%;">
                      <p class="title">{{ goodsItem.serviceTitle }}</p>
                      <span class="text"> {{ descriptionForGoods(goodsItem) }}</span>
                      <p class="text">NT$ {{ goodsItem.prices[0].price }}</p>
                    </div>
                    <div class="table__item qty" style="width: 25%;" :class="$style.goodsItem__changeNumContainer">
                      <el-button v-if="!addressEditCheck" type="info" round plain size="mini" icon="el-icon-minus" @click="changeNum(goodsItem, 'delete')" :disabled="goodsItem.qty <= 1"></el-button>
                      <div>{{ goodsItem.qty }}</div>
                      <el-button
                        v-if="!addressEditCheck"
                        type="primary"
                        round
                        plain
                        size="mini"
                        icon="el-icon-plus"
                        @click="changeNum(goodsItem, 'add')"
                        :disabled="goodsItem.qty >= goodsItem.inventory"
                      ></el-button>
                    </div>
                    <div class="table__item price" :class="$style.goodsItem__price">
                      <template v-if="isHasLevel && (goodsItem.price || goodsItem.total)">
                        <span style="display:none">TotalStatement 2gB</span>會員價：
                        {{
                          formatMemberLevelPrice({
                            price: goodsItem.prices[0].price,
                          })
                        }}
                        <br />
                        <del class="line-through-price">售價：{{ goodsItem.total || goodsItem.prices[0].price }}</del>
                      </template>
                      <template v-else>
                        {{ goodsItem.total || goodsItem.prices[0].price * goodsItem.qty }}
                      </template>
                    </div>
                    <div style="width: 10%;">
                      <!-- <BaseIcon name="trash-alt" />@click="handleRemoveGoods(goodsItem)" -->
                    </div>
                  </div>
                </template>
                <div v-if="hasCouponInfo" class="table__row">
                  <div class="table__title">{{ `優惠券(${couponItem.code})` }}</div>
                  <div class="table__single">
                    {{ couponPriceTotal - (isHasLevel && memberInfo.level.discount && memberInfo.level.discount.cosmetic ? formatMemberLevelPrice({ price: goodsPriceTotal }) : goodsPriceTotal) }}
                  </div>
                  <div class="table__button"> </div>
                </div>
              </template>
            </div>

            <template v-if="totalEditParams.length > 0">
              <div class="table__box" :class="{ isHasLevel: isHasLevel }">
                <div v-for="(item, index) in totalEditParams" :key="index" class="table__row">
                  <div class="table__title" style="width: 45%;">
                    <span v-html="formatParamTitle(item)"></span>
                    <span>{{ item.type === '%' ? `${item.price} % ` : item.price }}</span>
                  </div>
                  <template v-if="item.id !== undefined">
                    <div class="table__item price" style="width: 25%;">
                      <template v-if="item.type === 'cosmetic-add' && item.levelDiscount > 0">
                        <span style="display:none">TotalStatement F</span>會員價： {{ item.price - item.levelDiscountValue / item.qty }}
                        <br />
                        <del class="line-through-price">售價：{{ item.price }}</del>
                      </template>
                      <span v-else>{{ item.type === '%' ? `${item.description} % ` : item.price }}</span>
                    </div>
                    <div class="table__item qty">x{{ item.qty }}</div>
                    <div class="table__item count" style="display: flex; justify-content: end;">{{ item.type === '%' ? formatParamPrice(item) : item.total }}</div>
                  </template>
                  <template v-else>
                    <div class="table__item price" :class="{ isHasLevelItem: isHasLevel }">
                      <template v-if="isChildOrdersHasLevel(item, 'services') > -1 && item.type === 'cosmetic-add' && !!item.price">
                        <span style="display:none">TotalStatement G</span>會員價：
                        {{
                          formatMemberLevelPrice({
                            price: item.price,
                            totalStatus: false,
                            cosmeticAddItem: item,
                          })
                        }}
                        <br />
                        <del class="line-through-price">售價：{{ item.price }}</del>
                      </template>
                    </div>
                    <div class="table__item count">{{ formatParamPrice(item) }}</div>
                  </template>
                  <div class="table__button">
                    <div v-if="enabledEdit && showStatus(item)" @click="deleteParamItem(item, index)">
                      <BaseIcon name="trash-alt" class="isStyleSecondary"></BaseIcon>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div class="table__box" style="margin-top: 10px">
              <div class="table__row">
                <div class="table__title" style="width: 70%"> <span style="display:none">TotalStatement 2gC</span>應付金額 </div>
                <div class="table__single" style="width: 20%; display: flex; justify-content: end;">{{ submitPriceTotal }}</div>
                <div style="width: 10%"></div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss" module>
.wrapper {
  position: relative;
  height: 100%;
  width: 100%; // 商品要加上width: 100%;
}
.wrapperForGoods {
  position: relative;
  height: 100%; // 原本height是57%
  width: 100%;
  overflow: scroll;
}
.goodsItem {
  display: flex;
  align-items: center;

  :global {
    .changeNum {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #bec4c6;
      border-radius: $border-radius;
    }
  }

  &__changeNumContainer {
    width: 30%;
    gap: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__price {
    width: 20% !important;
    display: flex;
    justify-content: end;
  }

  &__titleRegion {
    :global {
      .title {
        font-size: 14px;
        color: $color-secondary;
        margin-top: 4px;
        margin-bottom: 4px;
        font-weight: 600;
      }

      .text {
        font-size: 13px;
        color: $color-text-light;
        margin-top: 4px;
        margin-bottom: 4px;
      }
    }
  }
}

.table {
  padding: 20px 30px 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  @include touch {
    padding-bottom: 30px;
  }

  @include max-md {
    padding: 20px;
  }

  :global {
    .table {
      &__head {
        background-color: #e5e7eb;
        display: flex;
        padding: 10px;
        justify-content: space-between;
        margin-bottom: 10px;

        .table__title {
          color: $color-text-light;
        }

        .table__item {
          color: $color-text-light;
        }

        &.isEdit {
          background-color: #fff;
          margin-bottom: 0;
        }
      }

      &__box {
        background-color: #fff;
        // margin-bottom: 10px;
      }

      &__row {
        display: flex;
        padding: 10px;
        justify-content: space-between;

        &:not(:last-child) {
          border-bottom: $color-border-base 1px solid;
        }
      }

      &__title {
        width: 30%;
        flex-shrink: 0;
        color: $color-secondary;
      }

      &__item {
        width: 20%;
        text-align: right;
        color: $color-secondary;

        &.price {
          width: 30%;
        }

        &.qty {
          width: 15%;
        }

        &.count {
          width: 15%;

          @include max-md {
            width: 20%;
          }
        }
      }

      &__single {
        width: 60%;
        text-align: right;
        color: $color-secondary;
      }

      &__button {
        width: 10%;
        text-align: right;
        color: $color-state-info;
        cursor: pointer;
      }

      &__scroll {
        flex: 1;
        overflow: auto;
      }

      &__goodsScroll {
        flex: 1;
      }
    }
  }
}

.payment {
  :global {
    li {
      line-height: 40px;
    }

    .title {
      margin-right: 20px;
      color: darkgray;
    }
  }
}
</style>
